// D-267 — customer-page engagement tabs: empty-state and "no permission to add" notice.
// Pure, so it can be unit-tested without a DOM.
export function engagementTabNotices(opts: { count: number; canWrite: boolean }): {
  showEmpty: boolean;
  showNoPermissionNotice: boolean;
} {
  return { showEmpty: opts.count === 0, showNoPermissionNotice: !opts.canWrite };
}
